import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    periodo: moment(new Date()).format('YYYY-MM-DD'),
    periodoDia: 1,
    periodoMes: 0,
    periodoMesNombre: null,
    periodoAnio: 0,
    sac: false,
    observaciones: '',
    
    liquidacionesPersonal: [],
    totalLiquidacion: 0,
    totales: [],

    liquidacionSueldosDatos: [],
    liquidacionSueldosPersonalDatos: [],
    liquidacionSueldosPagosDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, liquidacionSueldosId) {
        let fecha = moment.utc(new Date()).format('YYYY-MM-DD');

        state.id = liquidacionSueldosId | 0;
        state.periodo = fecha;
        state.periodoMes= new Date(fecha).getMonth() + 1;
        state.periodoMesNombre= helpers.methods.getMesNombre(state.periodoMes);
        state.periodoAnio= new Date(fecha).getFullYear();
        state.sac = false;
        state.observaciones = '';

        state.liquidacionesPersonal = [];
        state.totalLiquidacion = 0;
        state.totales = [];
    },
    'SET_LIQUIDACION_SUELDOS' (state, liquidacionSueldos) {
        state.periodo = moment(liquidacionSueldos.periodo).format('YYYY-MM-DD')
        state.periodoMes= new Date(liquidacionSueldos.periodo).getMonth() + 1;
        state.periodoMesNombre= helpers.methods.getMesNombre(state.periodoMes);
        state.periodoAnio= new Date(liquidacionSueldos.periodo).getFullYear();
        state.sac = liquidacionSueldos.sac;
        state.liquidacionesPersonal = liquidacionSueldos.liquidacionesPersonal;

        state.liquidacionesPersonal.sort(function(a, b){
            let x = a.personal.toLowerCase().trim();
            let y = b.personal.toLowerCase().trim();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });

        calcularTotales(state);
    },
    'CALCULAR_TOTALES'(state) {
        calcularTotales(state);
    },

    'INICIALIZAR_DATOS' (state) {
        state.liquidacionSueldosDatos = [];
        state.liquidacionSueldosPersonalDatos = [];
        state.liquidacionSueldosPagosDatos = [];
    },
    'SET_DATOS' (state, params) {
        state.liquidacionSueldosDatos = params.liquidacionSueldosDatos;
        if (params.liquidacionSueldosPersonalDatos) {
            state.liquidacionSueldosPersonalDatos = params.liquidacionSueldosPersonalDatos;
        }
        if (params.liquidacionSueldosPagosDatos) {
            state.liquidacionSueldosPagosDatos = params.liquidacionSueldosPagosDatos;
        }
        
        state.liquidacionSueldosPersonalDatos.sort(function(a, b){
                let x = a.personal.toLowerCase().trim();
                let y = b.personal.toLowerCase().trim();
                if (x < y) { 
                    return -1; 
                }
                if (x > y) {
                    return 1;
                }
                return 0;
            });

        state.liquidacionSueldosPersonalDatos = state.liquidacionSueldosPersonalDatos.map((personal, index) => ({
            numero: index + 1,
            ...personal
        }));
    },
};

function calcularTotales(state) {
    /* Calculamos total por personal */
    state.liquidacionesPersonal.forEach(personal => {
        let honorarios = 0;
        if (personal.honorarios) {
            if (!isNaN(personal.honorarios)) {
                honorarios = parseFloat(personal.honorarios);
            }
        }
        let adicional = 0;
        if (personal.adicional) {
            if (!isNaN(personal.adicional)) {
                adicional = parseFloat(personal.adicional);
            }
        }
        let otrosConceptos = 0;
        if (personal.otrosConceptos) {
            if (!isNaN(personal.otrosConceptos)) {
                otrosConceptos = parseFloat(personal.otrosConceptos);
            }
        }
        let liquidacionFinal = 0;
        if (personal.liquidacionFinal) {
            if (!isNaN(personal.liquidacionFinal)) {
                liquidacionFinal = parseFloat(personal.liquidacionFinal);
            }
        }
        let adelantos = 0;
        if (personal.adelantos) {
            if (!isNaN(personal.adelantos)) {
                adelantos = parseFloat(personal.adelantos);
            }
        }

        personal.total =  honorarios + adicional + otrosConceptos + liquidacionFinal - adelantos;
    });

    // state.totalLiquidacion = state.liquidacionesPersonal
    //     .reduce((total, personal) => {
    //         return total + personal.honorarios + personal.adicional}, 0);
    
    let totalHonorarios = state.liquidacionesPersonal
        .reduce((total, personal) => {
            let honorarios = 0;
            if (personal.honorarios) {
                if (!isNaN(personal.honorarios)) {
                    honorarios = parseFloat(personal.honorarios);
                }
            }
            return total + parseFloat(honorarios);
        }, 0);

    let totalAdicionales = state.liquidacionesPersonal
        .reduce((total, personal) => {
            let adicional = 0;
            if (personal.adicional) {
                if (!isNaN(personal.adicional)) {
                    adicional = parseFloat(personal.adicional);
                }
            }
            return total + parseFloat(adicional)
        }, 0);

    let totalOtrosConceptos = state.liquidacionesPersonal
        .reduce((total, personal) => {
            let otrosConceptos = 0;
            if (personal.otrosConceptos) {
                if (!isNaN(personal.otrosConceptos)) {
                    otrosConceptos = parseFloat(personal.otrosConceptos);
                }
            }
            return total + parseFloat(otrosConceptos)
        }, 0);

    let totalLiquidacionesFinales = state.liquidacionesPersonal
        .reduce((total, personal) => {
            let liquidacionFinal = 0;
            if (personal.liquidacionFinal) {
                if (!isNaN(personal.liquidacionFinal)) {
                    liquidacionFinal = parseFloat(personal.liquidacionFinal);
                }
            }
            return total + parseFloat(liquidacionFinal)
        }, 0);

    let totalAdelantos = state.liquidacionesPersonal
        .reduce((total, personal) => {
            let adelantos = 0;
            if (personal.adelantos) {
                if (!isNaN(personal.adelantos)) {
                    adelantos = parseFloat(personal.adelantos);
                }
            }
            return total + parseFloat(adelantos)
        }, 0);

    let totalGeneral = state.liquidacionesPersonal
        .reduce((total, personal) => {
            let totalPersonal = 0;
            if (personal.total) {
                if (!isNaN(personal.total)) {
                    totalPersonal = parseFloat(personal.total);
                }
            }
            return total + parseFloat(totalPersonal)
        }, 0);

    state.totalLiquidacion = parseFloat(totalHonorarios)
        + parseFloat(totalAdicionales)
        + parseFloat(totalOtrosConceptos)
        + parseFloat(totalLiquidacionesFinales)
        - parseFloat(totalAdelantos);

    state.totales = [];
    state.totales.push({
        totales: 'TOTALES',
        honorarios: totalHonorarios,
        adicional: totalAdicionales,
        otrosConceptos: totalOtrosConceptos,
        liquidacionFinal: totalLiquidacionesFinales,
        adelantos: totalAdelantos,
        total: totalGeneral
    })
}

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit } ) {
        commit('INICIALIZAR');
    },
    inicializarPeriodo ( { commit } ) {
        return new Promise((resolve, reject) => {
            /* Recuperamos los datos del periodo a liquidar */
            let periodo = parseInt(state.periodoAnio).toString().trim()
                + '-' + helpers.methods.getMesNumero(state.periodoMesNombre).toString().trim()
                + '-01';

            let queryString = '?periodo='+ periodo
                + '&sac='+ state.sac;

            apiAxios.get('liquidaciones-sueldos/abm' + queryString) 
                .then(res => {
                    commit('SET_LIQUIDACION_SUELDOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getLiquidacionSueldos ( { commit }, liquidacionSueldosId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', liquidacionSueldosId);

            apiAxios.get(`liquidaciones-sueldos/${liquidacionSueldosId}/abm`)
                .then(res => {
                    commit('SET_LIQUIDACION_SUELDOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (save) {
                let periodo = parseInt(state.periodoAnio).toString().trim()
                    + '-' + helpers.methods.getMesNumero(state.periodoMesNombre).toString().trim()
                    + '-01';

                
                /* Validamos los montos de los distintos conceptos */
                state.liquidacionesPersonal.forEach(personal => {
                    let honorarios = 0;
                    if (personal.honorarios) {
                        if (!isNaN(personal.honorarios)) {
                            honorarios = parseFloat(personal.honorarios);
                        }
                    }
                    let adicional = 0;
                    if (personal.adicional) {
                        if (!isNaN(personal.adicional)) {
                            adicional = parseFloat(personal.adicional);
                        }
                    }
                    let otrosConceptos = 0;
                    if (personal.otrosConceptos) {
                        if (!isNaN(personal.otrosConceptos)) {
                            otrosConceptos = parseFloat(personal.otrosConceptos);
                        }
                    }
                    let liquidacionFinal = 0;
                    if (personal.liquidacionFinal) {
                        if (!isNaN(personal.liquidacionFinal)) {
                            liquidacionFinal = parseFloat(personal.liquidacionFinal);
                        }
                    }
                    
                    personal.honorarios = parseFloat(honorarios);
                    personal.adicional = parseFloat(adicional);
                    personal.otrosConceptos = parseFloat(otrosConceptos);
                    personal.liquidacionFinal = parseFloat(liquidacionFinal);
                });

                let liquidacionesPersonal = state.liquidacionesPersonal
                    .map( liquidacionPersonal => ({
                        personalId: liquidacionPersonal.personalId,
                        cargoId: liquidacionPersonal.cargoId,
                        honorarios: liquidacionPersonal.honorarios,
                        adicional: liquidacionPersonal.adicional,
                        otrosConceptos: liquidacionPersonal.otrosConceptos,
                        liquidacionFinal: liquidacionPersonal.liquidacionFinal,
                        adelantos: parseFloat(liquidacionPersonal.adelantos)
                    }));

                let liquidacion = {
                    periodo: periodo,
                    sac: ((/true/i).test(state.sac)),
                    observaciones: state.observaciones.trim(),
                    liquidacionesPersonal
                };

                let url = 'liquidaciones-sueldos';
                if (state.id != 0) {
                    // personal.rowVersion = state.rowVersion;
                    url += '/' + state.id;
                }
    
                apiAxios.post(url, liquidacion)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    calcularTotales ( { commit } ) {
        commit('CALCULAR_TOTALES');
    },
    getDatos ( { commit }, liquidacionSueldosId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (liquidacionSueldosId) {
                apiAxios.get('liquidaciones-sueldos/' + liquidacionSueldosId ) 
                    .then(res => {
                        let liquidacionSueldosDatos = [
                            { 'nombre': 'fechaRegistro', 'campo': 'Fecha', 'valor': res.data.fechaRegistro, 'formato': 'fecha' },
                            { 'nombre': 'periodo', 'campo': 'Periodo', 'valor': res.data.periodo, 'formato': 'periodo' },
                            { 'nombre': 'total', 'campo': 'Total', 'valor': res.data.total, 'formato': 'moneda' },
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' },
                        ]
                        
                        let params = {
                            liquidacionSueldosDatos,
                            liquidacionSueldosPersonalDatos: res.data.liquidacionesPersonal,
                            liquidacionSueldosPagosDatos: res.data.pagos
                        }
                                      
                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}